import type { NicePayCallbackResponseData } from './nicePayCallbackResponseData';

export interface NicePayCallbackResponse {
  /** 응답 데이터 */
  data?: NicePayCallbackResponseData;
  /** 응답 메시지 */
  message: string;
  /** 성공 여부 */
  success: boolean;
}
